export default __webpack_public_path__ + "static/media/675.48d65a5b.png";